import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Detalle de "C - Gestión & Contenidos" (ingresos de cartelería) del ER v2 para un mes.
 * Solo lectura. Lista los negocios de cartelería activos del mes con su referencia/cliente,
 * pantallas e importe local, tal como los arma `detalleGestionContenidosPorMes` (hook v1
 * `useGestionCalcs`, en lectura). A diferencia del GestionContenidosModal del v1, NO edita
 * fechas ni hace refetch: el detalle ya viene calculado en scope.
 *
 * El total es Σ item.totalLocal, que por construcción coincide con el ingreso de la celda
 * del header (mismo hook: `ingresosGestionContenidosMensual`). Se usa `formatCurrency` con el
 * mesIndex para respetar el modo USD y que el total cierre con la celda.
 */
export const DetalleGestionContenidosModal = ({ isOpen, mes, mesIndex, items = [], formatCurrency, onClose }) => {
  if (!isOpen) return null;

  const total = items.reduce((sum, it) => sum + (it.totalLocal || 0), 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Gestión &amp; Contenidos — {mes}</h3>

        {items.length === 0 ? (
          <p style={{ margin: "16px 0", color: "#666", fontSize: "0.9rem" }}>
            No hay negocios de cartelería en este mes.
          </p>
        ) : (
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Cliente / Edificio</th>
                <th style={{ textAlign: "center" }}>Tipo</th>
                <th style={{ textAlign: "center" }}>Pantallas</th>
                <th style={{ textAlign: "end" }}>Importe</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={`${it.id}-${i}`}>
                  <td style={{ textAlign: "left" }}>{it.nombre}</td>
                  <td style={{ textAlign: "center" }}>{it.tipo}</td>
                  <td style={{ textAlign: "center" }}>{it.pantallas}</td>
                  <td style={{ textAlign: "end" }}>{formatCurrency(it.totalLocal, mesIndex)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} style={{ textAlign: "end", fontWeight: 600 }}>
                  Total
                </td>
                <td style={{ textAlign: "end", fontWeight: 600 }}>{formatCurrency(total, mesIndex)}</td>
              </tr>
            </tfoot>
          </table>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
